

import { readConfig } from "./indexos-config.js";
import { CollectionController } from "./indexos-collection-controller.js";
import * as IndexOsHistory from "./indexos-history.js";
import {
  detectCustomSort,
  isCustomSort,
  parseSortValue,
} from "./indexos-sort-detector.js";

let activeController = null;

function boot() {

  IndexOsHistory.installHistoryGuard?.();

  const root = document.querySelector("[data-indexos-collection]");
  if (!root) return null;

  if (activeController) {
    activeController.destroy();
    activeController = null;
  }

  const config = readConfig(root);
  const controller = new CollectionController(config);
  controller.start();
  activeController = controller;

  window.IndexOS = {
    ...(window.IndexOS || {}),
    version: "1.0.0",
    controller,
    config,
    detectCustomSort,
    isCustomSort,
    parseSortValue,
    reboot: boot,

    async test(sort = "rating", direction = "desc") {
      const url = new URL(config.proxyPath, window.location.origin);
      url.searchParams.set("collection", config.collection);
      url.searchParams.set("sort", sort);
      url.searchParams.set("direction", direction);
      url.searchParams.set("page", "1");
      url.searchParams.set("limit", String(config.pageSize));

      const report = {
        collection: config.collection,
        gridFound: Boolean(document.querySelector(config.selectors.grid)),
        sortSelectFound: Boolean(
          document.querySelector(config.selectors.sortSelect),
        ),
        proxyUrl: url.toString(),
      };

      try {
        const response = await fetch(url.toString(), {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        });
        report.status = response.status;
        report.contentType = response.headers.get("content-type");
        const text = await response.text();
        try {
          const body = JSON.parse(text);
          report.productCount = body?.products?.length ?? null;
          report.total = body?.total ?? null;
          report.body = body;
        } catch {

          report.body = text.slice(0, 300);
        }
      } catch (error) {
        report.error = String(error);
      }

      console.table?.([
        {
          collection: report.collection,
          status: report.status,
          products: report.productCount,
          gridFound: report.gridFound,
          sortSelectFound: report.sortSelectFound,
        },
      ]);
      console.log("[IndexOS] diagnostic", report);
      return report;
    },
  };

  return controller;
}

function onReady(fn) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn, { once: true });
  } else {
    fn();
  }
}

onReady(boot);

window.addEventListener("pageshow", (event) => {
  if (!event.persisted) return;
  const grid = document.querySelector(
    "[data-indexos-grid], [data-product-container], .m-collection-products",
  );
  if (grid) {
    grid
      .querySelectorAll(".m-scroll-trigger, .scroll-trigger, .m-scroll-trigger--cancel")
      .forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        node.style.opacity = "1";
        node.style.visibility = "visible";
        node.style.transform = "none";
      });
  }
  requestAnimationFrame(() => boot());
});

document.addEventListener("collection:rerendered", () => {
  requestAnimationFrame(() => boot());
});

export {
  boot,
  CollectionController,
  detectCustomSort,
  isCustomSort,
  parseSortValue,
};
